import { FC, ReactNode } from "react";
import { Icon } from "../Icon/Icon";
import { useMemo } from "react";
import { IconNames } from "../Icon/svg";
import classes from "./Box.module.scss";
import { v4 as uuidv4 } from "uuid";
import clsx from "clsx";
import { useMatchMedia } from "../../hooks/useMatchMedia";

export interface BoxProps {
	image: string;
	title: string;
	links?: IconNames[];
	children: ReactNode;
	className: string;
}

export interface BoxComponent extends FC<BoxProps> {}

export const Box: BoxComponent = ({
	image,
	title,
	children,
	links,
	className,
}) => {
	const wrapperClassName = useMemo(
		() =>
			clsx(
				classes.wrapper,

				{},
				className
			),
		[className]
	);

	return (
		<div className={wrapperClassName}>
			<img className={classes.image} src={image} alt="" />
			<div className={classes.content}>
				<h3 className={classes.title}>{title}</h3>
				{links?.map((link: IconNames) => (
					<Icon className={classes.icon} key={uuidv4()} name={link} />
				))}
			</div>
			<span className={classes.text}>{children}</span>
		</div>
	);
};
